import React, { useState, useEffect } from "react";
import Navbar from "../components/Navbar";
import axios from "axios";
import SuccessMessage from "../components/SuccessMessage";
// import { useNavigate } from "react-router-dom";
import { MdDeleteForever } from "react-icons/md";
import { FaArrowRightLong } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

function Cart() {
    const [cartItems, setCartItems] = useState([]);
    const [orderSuccess, setOrderSuccess] = useState(false);
    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
    const apiLocalUrl = process.env.REACT_APP_API_LOCAL_URL;
    // const customerType = localStorage.getItem("CustomerType");
    // const Ledcode = localStorage.getItem("Ledcode");
    // const LedName = localStorage.getItem("LedName");
    const { isLoggedIn, userInfo, loading } = useAuth();
    const customerType = userInfo?.CustomerType;
    const Ledcode = userInfo?.Ledcode;
    const LedName = userInfo?.LedName;

    const navigate = useNavigate();

    // console.log("customerType:",customerType);

    // useEffect(() => {
    //     const storedData = JSON.parse(localStorage.getItem("productData")) || [];
    //     setCartItems(storedData);
    // }, []);

    useEffect(() => {
        if (!loading && !isLoggedIn) {
            navigate("/"); // Redirect to home if not logged in
        }
    }, [loading, isLoggedIn, navigate]);

    useEffect(() => {
        if (loading || !isLoggedIn) return;

        const fetchCartData = async () => {
            try {
                const ledcode = userInfo?.Ledcode;
                if (!ledcode) {
                    console.warn("Ledcode not found");
                    return;
                }

                const res = await axios.get(`${apiBaseUrl}/cart/items/JAPAN_ACCESORIES/${ledcode}`);
                if (res.data?.success && Array.isArray(res.data.items)) {
                    const serverCartItems = res.data.items.map((item) => ({
                        itemName: item.itemName,
                        id: item.itemId,
                        mop: item.itemPrice,
                        dp: item.itemPrice,
                        mrp: item.itemPrice,
                        quantity: item.quantity,
                        uniqueCode: item.uniqueCode || "0",
                        selectedModel: item.selectedModel || "",
                        branch: item.branch || "",
                        realpratetax: item.realpratetax || 0,
                    }));
                    setCartItems(serverCartItems);
                }
            } catch (error) {
                console.error("Error fetching cart from API:", error);
            }
        };

        fetchCartData();
    }, [loading, isLoggedIn, userInfo, apiBaseUrl]);

    // const removeFromCart = (id) => {
    //     const updatedCart = cartItems.filter((item) => item.id !== id);
    //     setCartItems(updatedCart);
    //     localStorage.setItem("productData", JSON.stringify(updatedCart));
    // };

    const removeFromCart = async (itemId) => {
        try {
            const ledcode = userInfo?.Ledcode; // assuming you're using AuthContext
            if (!ledcode) {
                console.error("LED code is missing");
                return;
            }

            const response = await axios.delete(`${apiBaseUrl}/cart/item/JAPAN_ACCESORIES/${itemId}/${ledcode}`);

            if (response.data?.success) {
                // Remove from UI state
                const updatedCart = cartItems.filter((item) => item.id !== itemId);
                setCartItems(updatedCart);
            } else {
                console.error("Failed to delete item:", response.data);
            }
        } catch (error) {
            console.error("Error deleting item from cart:", error);
        }
    };

    // const getPriceBasedOnCustomerType = (item) => {
    //     switch (customerType) {
    //         case "CUSTOMER":
    //             return item.mop;
    //         case "DEALER":
    //             return item.dp;
    //         case "JS_MANAGER":
    //             return item.mop;
    //         case "JS_EMPLOYEE":
    //             return item.mop;
    //         case "TK_MANAGER":
    //             return item.mop;
    //         case "TK_EMPLOYEE":
    //             return item.mop;
    //         default:
    //             return item.mrp; // Default customerType is unknown
    //     }
    // };

    const getPriceBasedOnCustomerType = (item) => {
        const defaultPrice = item.mrp || item.mop || item.dp || item.ap || 0; // safe fallback
        switch (customerType) {
            case "CUSTOMER":
            case "JS_MANAGER":
            case "JS_EMPLOYEE":
            case "TK_MANAGER":
            case "TK_EMPLOYEE":
                return item.mop ?? defaultPrice;
            case "DEALER":
                return item.dp ?? defaultPrice;
            case "AGENT":
                return item.ap ?? defaultPrice;
            default:
                return defaultPrice;
        }
    };

    const currentDate = new Date().toLocaleDateString("en-GB").split("/").reverse().join("-");
    const mobile = "";

    const total = cartItems
        .reduce((total, item) => total + parseFloat(getPriceBasedOnCustomerType(item)) * parseFloat(item.quantity), 0)
        .toFixed(2);

    const cDate = new Date().toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
    });

    const handleQuantityChange = (id, action) => {
        const updatedCart = cartItems.map((item) => {
            if (item.id === id) {
                let newQty = action === "increment" ? item.quantity + 1 : item.quantity - 1;
                if (newQty < 1) newQty = 1;

                // Call the API to update quantity
                updateCartItemQuantity(item.id, newQty, getPriceBasedOnCustomerType(item), item.itemName);

                return { ...item, quantity: newQty };
            }
            return item;
        });

        setCartItems(updatedCart);
        localStorage.setItem("productData", JSON.stringify(updatedCart));
    };

    const updateCartItemQuantity = async (itemId, newQuantity, itemPrice, itemName) => {
        try {
            await axios.put(
                `${apiBaseUrl}/cart/item/update/JAPAN_ACCESORIES/${itemId}/${Ledcode}`,
                {
                    quantity: newQuantity,
                    itemPrice,
                    itemName,
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );
        } catch (error) {
            console.error("Failed to update item quantity:", error);
        }
    };

    const handleClearCart = async () => {
        try {
            const response = await axios.delete(
                `${apiBaseUrl}/cart/clear/JAPAN_ACCESORIES/${Ledcode}`,
                {},
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );

            if (response.data?.success) {
                setCartItems([]); // Clear cart
                localStorage.removeItem("productData");
                // alert("cleared");
            } else {
                console.error("Failed to clear cart:", response.data);
                // alert("failed");
            }
        } catch (error) {
            console.error("Error clearing cart:", error);
            // alert("error occurred .");
        }
    };

    const handleSubmit = async () => {
        if (cartItems.length === 0) {
            alert("Cart is empty");
            return;
        }
        navigate("/adrs");

        const items = cartItems
            .map(
                (item) =>
                    `{\\"id\\":${item.id},\\"name\\":\\"${item.itemName}\\",\\"model\\":\\"${
                        item.selectedModel
                    }\\",\\"dp\\":${getPriceBasedOnCustomerType(item).toFixed(2)},\\"mrp\\":${(
                        parseFloat(getPriceBasedOnCustomerType(item)) * parseInt(item.quantity)
                    ).toFixed(2)},\\"quantity\\":${item.quantity}}`
            )
            .join(",");

        const order = `{"date":"${currentDate}","id":"${Ledcode}","contact":"${mobile}","items":"[${items}]"}`;

        console.log("order:", order);

        try {
            const response = await axios.post(`${apiBaseUrl}/orderAdd/JAPAN_ACCESORIES`, JSON.parse(order), {
                headers: {
                    "Content-Type": "application/json",
                },
            });
            console.log("Order response:", response.data);
            setOrderSuccess(true);
            handleClearCart()

            let tableText = `Date: ${cDate}\nCustomer Name: ${LedName}\n\nCheckout my cart items:\n\n`;

            // Prepare the WhatsApp message
            const message = cartItems
                .map(
                    (item) =>
                        `Product: ${item.itemName}\nModel: ${item.selectedModel}\nPrice: ${getPriceBasedOnCustomerType(
                            item
                        ).toFixed(2)}\nQuantity: ${item.quantity}`
                )
                .join("\n\n");

            tableText += message + "\n";

            const totalAmountText = `\n\nTotal Amount: ${total}`;

            tableText += totalAmountText + "\n";

            const encodedMessage = encodeURIComponent(tableText);
            window.location.href = `whatsapp://send?text=${encodedMessage}`;
        } catch (error) {
            console.error("Error placing order:", error);
            // Handle error, e.g., show error message
        }
    };

    // const address = async () => {
    //     navigate("/address");
    // };

    const handleWishlist = async () => {
        navigate("/wishlist");
    };

    return (
        <div className="min-h-screen flex flex-col  flex-1 pb-5 ">
            <div className="sticky top-0 z-50">
                <Navbar />
            </div>

            {orderSuccess && <SuccessMessage message="Order placed successfully!" total={total} />}
            {cartItems.length === 0 ? (
                <div className="w-full flex flex-col justify-center items-center h-[80vh] gap-4">
                    <div className="w-full text-center">
                        <span className="text-xl font-medium font-display text-[#c61c1c]">No items in cart</span>
                    </div>

                    <div className="w-full flex justify-center">
                        {customerType === "CUSTOMER" && (
                            <button
                                className="border-2 border-black rounded-md px-4 py-2 font-semibold"
                                onClick={handleWishlist}
                            >
                                Add from wishlist
                            </button>
                        )}
                    </div>
                </div>
            ) : (
                <div className="w-full lg:px-[7%] px-[2%] flex flex-col  mt-5">
                    <div className="w-full flex lg:flex-row flex-col gap-8 mt-8">
                        <div className="lg:w-[70%] w-full h-fit flex flex-col">
                            <div className=" w-full h-fit flex flex-col border-2 border-[#EAEAEC] rounded-md">
                                <div className="flex justify-between w-full">
                                    <span className="font-bold text-xl font-display px-4 py-4">Shopping Cart</span>
                                    <span
                                        className="font-semibold text-lg font-display px-4 py-4 text-[#c61c1c] cursor-pointer"
                                        onClick={handleClearCart}
                                    >
                                        Clear Cart
                                    </span>
                                </div>

                                {/* Table Header - Desktop Only */}
                                <div className="hidden lg:grid grid-cols-10 gap-4 bg-[#FFF6F4] px-4 py-3 mt-4 text-sm font-semibold text-[#2e2e2e]">
                                    <p className="col-span-5 text-center">Product</p>
                                    <p className="col-span-1 text-center">Price</p>
                                    <p className="col-span-2 text-center">Quantity</p>
                                    <p className="col-span-2 text-center">Total</p>
                                </div>

                                {/* Table Rows */}
                                {cartItems.map((item) => (
                                    <div key={item.id} className="w-full px-4 py-4 mt-1  rounded-sm">
                                        <div className="grid grid-cols-1 lg:grid-cols-10 sm:grid-cols-6 gap-4 items-center">
                                            {/* Mobile: Delete Icon at Top Right */}
                                            <div className="block lg:hidden text-right">
                                                <MdDeleteForever
                                                    className="text-[#c61c1c] size-6 cursor-pointer inline-block"
                                                    onClick={() => removeFromCart(item.id, "delete")}
                                                />
                                            </div>

                                            {/* Desktop Only: Delete Icon */}
                                            <div className="hidden lg:flex justify-center">
                                                <MdDeleteForever
                                                    className="text-[#c61c1c] size-6 cursor-pointer"
                                                    onClick={() => removeFromCart(item.id, "delete")}
                                                />
                                            </div>

                                            {/* Product Info */}
                                            <div className="col-span-full lg:col-span-4 sm:col-span-3 flex items-center gap-3">
                                                <div className="w-16 h-16 bg-white rounded-md overflow-hidden">
                                                    <img
                                                        src={`${apiLocalUrl}/uploads/${item.id}.jpg?v=${Date.now()}`}
                                                        alt={item.itemName}
                                                        className="w-full h-full object-contain mix-blend-multiply"
                                                    />
                                                </div>
                                                <div>
                                                    <p className="text-sm font-medium">{item.itemName}</p>
                                                    <p className="text-xs text-gray-600 lg:hidden">
                                                        {/* Price: ₹{getPriceBasedOnCustomerType(item).toFixed(2)} */}
                                                        Price: ₹{Number(getPriceBasedOnCustomerType(item)).toFixed(2)}
                                                    </p>
                                                    <p className="text-xs text-gray-600 lg:hidden">
                                                        Total: ₹
                                                        {(getPriceBasedOnCustomerType(item) * item.quantity).toFixed(2)}
                                                    </p>
                                                </div>
                                            </div>

                                            {/* Desktop Only: Unit Price */}
                                            <div className="hidden lg:block col-span-1 text-center text-sm font-medium text-gray-700">
                                                {/* ₹{getPriceBasedOnCustomerType(item).toFixed(2)} */}₹
                                                {Number(getPriceBasedOnCustomerType(item)).toFixed(2)}
                                            </div>

                                            {/* Quantity Controls */}
                                            <div className="col-span-full sm:col-span-2 lg:col-span-2 flex justify-center">
                                                <div className="w-[100px] h-9 border-2 border-[#EAEAEC] rounded-[10px] flex items-center justify-between px-3">
                                                    <button
                                                        className="text-sm font-semibold"
                                                        onClick={() => handleQuantityChange(item.id, "decrement")}
                                                    >
                                                        −
                                                    </button>
                                                    <span className="text-base font-semibold">{item.quantity}</span>
                                                    <button
                                                        className="text-sm font-semibold"
                                                        onClick={() => handleQuantityChange(item.id, "increment")}
                                                    >
                                                        +
                                                    </button>
                                                </div>
                                            </div>

                                            {/* Desktop Only: Total */}
                                            <div className="hidden lg:block text-sm font-semibold text-[#333] col-span-2 text-center">
                                                ₹{(getPriceBasedOnCustomerType(item) * item.quantity).toFixed(2)}
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div className="flex justify-end mt-4">
                                {customerType === "CUSTOMER" && (
                                    <button
                                        className="border-2 border-black rounded-md px-4 py-2 font-semibold"
                                        onClick={handleWishlist}
                                    >
                                        Add more from wishlist
                                    </button>
                                )}
                            </div>
                        </div>

                        <div className="w-full lg:w-[30%]">
                            <div className="w-full lg:w-[100%] flex flex-col lg:mb-0 sticky top-40">
                                <div className="border-2 rounded-md border-[#EAEAEC] pb-4 bg-white shadow-md">
                                    <div className="w-full h-[18%] bg-[#FFF6F4] px-3 py-3 flex justify-between items-center text-base font-[600] font-[display]">
                                        <span className="text-base font-[600] font-display">Price Details</span>
                                    </div>

                                    <div className="w-full h-[82%]   flex  flex-col px-3 gap-2">
                                        <ul className=" mt-5" />
                                        <div className="flex flex-col gap-5 w-full">
                                            <div className="w-full flex justify-between">
                                                <span className="text-base text-[#959596] font-display">
                                                    Sub Total ({cartItems.length})
                                                </span>
                                                <span className="text-base font-[600] font-display">₹{total}</span>
                                            </div>
                                            <div className="w-full flex justify-between">
                                                <span className="text-base text-[#959596] font-display">Shipping</span>
                                                <span className="text-base font-[600] font-display">₹00.00</span>
                                            </div>
                                            <div className="w-full flex justify-between">
                                                <span className="text-base text-[#959596] font-display">Discount</span>
                                                <span className="text-base font-[600] font-display">₹00.00</span>
                                            </div>
                                            <div className="w-full flex justify-between">
                                                <span className="text-base text-[#959596] font-display">Tax</span>
                                                <span className="text-base font-[600] font-display">₹00.00</span>
                                            </div>
                                        </div>
                                        <ul className="border-2 border-black mt-5 text-[#F0F0F0]" />
                                        <div className="w-full flex justify-between">
                                            <span className="text-base font-[600] font-display">Total Amount</span>
                                            <span className="text-base font-[600] font-display">
                                                ₹
                                                {cartItems
                                                    .reduce(
                                                        (total, item) =>
                                                            total +
                                                            parseFloat(getPriceBasedOnCustomerType(item)) *
                                                                parseFloat(item.quantity),
                                                        0
                                                    )
                                                    .toFixed(2)}
                                            </span>
                                        </div>
                                        {/* <ul className="border-b-2 border-black border-dashed " /> */}
                                    </div>
                                </div>

                                <div className="p-4 mt-9 rounded-md bg-[#EAEAEC]">
                                    <button
                                        className="h-[50px] w-full bg-[#BB002D] rounded-[5px] flex justify-center items-center text-base font-[500] font-display text-[white] cursor-pointer"
                                        onClick={handleSubmit}
                                    >
                                        PROCEED TO CHECKOUT
                                        <FaArrowRightLong className="ml-2" />
                                    </button>
                                </div>
                            </div>
                            {/* <div className=" h-[80px] bg-[#FFF6F4] justify-center lg:hidden flex items-center  fixed bottom-0 w-full">
                                <div
                                    className="h-[50px] w-[80%] bg-[#BB002D] rounded-[5px] flex justify-center items-center text-base font-[500] font-display text-[white] cursor-pointer"
                                    onClick={handleSubmit}
                                >
                                    PROCEED TO CHECKOUT
                                    <FaArrowRightLong />
                                </div>
                            </div> */}
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default Cart;
